module.exports = __webpack_public_path__ + "static/318243694_666024418527330_3637593781471252150_n.jpg-1671186393155_256-6e76f6ff033b26e708a1576c9e4442b9.webp";